export const load = () => ({
	h1: 'Make Your Windows Private and Protect from UV Rays',
	title: 'Privacy and UV Protection',
	description:
		'Indow custom window inserts provide cost-effective privacy and UV protective solutions. Block 100% visible light with sleep panels, reduce UV damage with museum grade panels, or diffuse light for privacy with privacy grade panels.',
	showTitle: true,
});
